import React, { useState } from 'react';
import { 
  Box, 
  Container, 
  Typography, 
  TextField, 
  Button, 
  Stack, 
  Paper,
  AppBar,
  Toolbar,
  Select,
  MenuItem
} from '@mui/material';
import { useForm, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface IFormInput {
  name: string;
  email: string;
}

function FormDemo() {
  const { t, i18n } = useTranslation();
  const { control, handleSubmit, formState: { errors } } = useForm<IFormInput>();
  const [submittedData, setSubmittedData] = useState<IFormInput | null>(null);

  const onSubmit = (data: IFormInput) => {
    setSubmittedData(data);
  };

  const changeLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Demo FSD App
          </Typography>
          <Select
            value={i18n.language}
            onChange={(e) => changeLanguage(e.target.value)}
            sx={{ color: 'white', '.MuiOutlinedInput-notchedOutline': { borderColor: 'transparent' } }}
            variant="outlined"
            size="small"
          >
            <MenuItem value="en">English</MenuItem>
            <MenuItem value="zh-cn">简体中文</MenuItem>
          </Select>
        </Toolbar>
      </AppBar>

      <Container maxWidth="sm" sx={{ mt: 4 }}>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom>
            {t('welcome')}
          </Typography>

          <form onSubmit={handleSubmit(onSubmit)}>
            <Stack spacing={3}>
              <Controller
                name="name"
                control={control}
                defaultValue=""
                rules={{ required: t('form.required') as string }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label={t('form.name')}
                    error={!!errors.name}
                    helperText={errors.name ? errors.name.message : ''}
                    fullWidth
                  />
                )}
              />

              <Controller
                name="email"
                control={control}
                defaultValue=""
                rules={{ 
                  required: t('form.required') as string,
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: "Invalid email address"
                  }
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label={t('form.email')}
                    error={!!errors.email}
                    helperText={errors.email ? errors.email.message : ''}
                    fullWidth
                  />
                )}
              />

              <Button type="submit" variant="contained" color="primary" size="large">
                {t('form.submit')}
              </Button>
            </Stack>
          </form>

          {submittedData && (
            <Box sx={{ mt: 4, p: 2, bgcolor: 'grey.100', borderRadius: 1 }}>
              <Typography variant="h6">Submitted Data:</Typography>
              <pre>{JSON.stringify(submittedData, null, 2)}</pre>
            </Box>
          )}
        </Paper>
      </Container>
    </Box>
  );
}

export default FormDemo;
